module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-6e4934c3!./packages/dof-board/diablo.css
// module id = 510
// module chunks = 0 1